import { styled } from '../../hooks/theme';

interface OptionProps {
  selected: boolean;
}

export const Container = styled.div`
  display: flex;
  align-items: stretch;
`;

export const Option = styled.button<OptionProps>`
  min-height: 100%;
  margin-right: 32px;
  padding: 12px 16px;

  border: 1px solid ${props => props.theme.colors.neutral.grey[40]};
  border-radius: 4px;
  background: none;
  transition: background 0.1s;
  cursor: pointer;
  text-align: left;

  display: flex;
  justify-content: space-between;

  &:hover {
    background: ${props => props.theme.colors.neutral.grey[5]};
  }
`;

export const TextContainer = styled.div`
  width: 200px;
  margin-right: 16px;

  p {
    font-family: ${props => props.theme.font.family.sans};
    color: ${props => props.theme.colors.neutral.grey[70]};
  }
`;

export const SelectToggle = styled.div`
  width: 20px;
  height: 20px;
  border: 1px solid ${props => props.theme.colors.neutral.grey[70]};
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
`;

export const SelectedCircle = styled.div`
  height: 16px;
  width: 16px;

  background: ${props => props.theme.colors.brand.primary[100]};
  border-radius: 50%;
`;
